import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';

import {
	TranslatedString,
	Dialog, DialogHeadline,
	PrimaryButton
} from '@bosch/bt-ui';

import './WarningDialog.css';
import withErrorHandler from './ErrorHandler';

const WarningDialog = (props) => {
	const {
		openWarning,
		descTranslatedId,
		setWarningOpen,
		headTranslatedId,
		onWarning = null
    } = props;

	const onCloseModal = () => setWarningOpen(false);

	return (
		<Dialog onClose={onCloseModal} 
			dialogOptions={{
				open: openWarning
			}}
			title={<TranslatedString stringId="dialog-warning" />}
			// Can be either "error", "warning", "success", "info", or "none"
			alertType="warning"
		>
			<DialogHeadline>
				<TranslatedString stringId={headTranslatedId} />
			</DialogHeadline>
			{descTranslatedId && (
				<div className="dialog-description">
					<TranslatedString stringId={descTranslatedId} />
				</div>
			)}
			<div className="dialog-warning-button">
				<PrimaryButton type="button" onClick={onWarning ?? onCloseModal}>
					<TranslatedString stringId="button-ok" />
				</PrimaryButton>
			</div>
		</Dialog>
	);
}

export default withErrorHandler(WarningDialog);